import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {firestoreConnect, withFirestore, isLoaded} from "react-redux-firebase";
import {UserIsAuthenticated} from "../utils/AuthManager";
import {connect} from "react-redux";
import {COMPANY_DB_PATH} from "../constants/DB_PATHS";
import withCompanyManagerHOC from "./auth/CompanyManagerHOC";
import {SERVICE_TYPES} from "../constants/ServiceTypes";
import {BackgroundDiv} from "./Containers";
import Navbar from "./Navbar";
import {PROFILE_URL} from "../constants/URLS";


class CompanyServicePrices extends Component {
    constructor() {
        super();
        this.state = {
            loaded: false,
            service: null,
            prices: {
                /*0: [
                    'csere 17", 1000, db',
                    'csere 19", 2000, db',
                ],


                1: [
                    'casdasdsere 17", 1000, db',
                    'cseqewqere 19", 2000, db',
                ],*/


            },
            text: '',
            price: '',
            unit: '',
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.company && this.props.company.prices && !this.state.loaded) {
            this.setState({
                prices: this.props.company.prices,
                loaded: true
            })
        }
    }

    removeItemFromArray = (index) => {
        const arr = this.state.prices[this.state.service]
        arr.splice(index, 1)
        this.setState({
            prices: {
                ...this.state.prices,
                [this.state.service]: arr
            }
        })
    }


    render() {
        if (this.props.company && isLoaded(this.props.company)) {
            console.log(this.props)
            console.log(this.state)
            return (
                <div>
                    <BackgroundDiv/>
                    <Navbar/>
                    <h1>Services</h1>
                    <div>
                        {Object.values(this.props.company.services).map((e, i) => {
                            return (
                                <div key={i} onClick={() => {
                                    this.setState({service: e})
                                }}>
                                    {SERVICE_TYPES[e].name} {e}
                                </div>
                            )
                        })}
                    </div>
                    {this.state.service !== null ?
                        <div>
                            <h2>{SERVICE_TYPES[this.state.service].name} Price</h2>
                            {this.state.prices[this.state.service] ?
                                <div>
                                    {Object.values(this.state.prices[this.state.service]).map((e, i) => {
                                        const info = e.split(',')
                                        return (
                                            <div key={i}>
                                                {info[0]} {info[1]}Ft{info[2] ? '/' + info[2] : null}
                                                <button
                                                    onClick={() => {
                                                        console.log(i)
                                                        //this.state.prices[this.state.service].splice(i,1)
                                                        this.removeItemFromArray(i)
                                                    }}
                                                >x
                                                </button>

                                            </div>
                                        )
                                    })}
                                    <div>
                                        <input type="text"
                                               value={this.state.text}
                                               onChange={e => {
                                                   this.setState({text: e.target.value})
                                               }}
                                        />
                                        <input type="text"
                                               value={this.state.price}
                                               onChange={e => {
                                                   this.setState({price: e.target.value})
                                               }}
                                        />
                                        <input type="text"
                                               value={this.state.unit}
                                               onChange={e => {
                                                   this.setState({unit: e.target.value})
                                               }}
                                        />
                                        <button onClick={() => {

                                            this.setState({
                                                text: '',
                                                price: '',
                                                unit: '',
                                                prices: {
                                                    ...this.state.prices,
                                                    [this.state.service]: this.state.prices[this.state.service].concat(
                                                        /*[[
                                                            String(this.state.text),
                                                            Number(this.state.price),
                                                            String(this.state.unit)
                                                        ]]*/
                                                        [String(this.state.text + ',' + this.state.price + ',' + this.state.unit)]
                                                    )


                                                }
                                            })
                                        }}>Add
                                        </button>
                                    </div>
                                </div>
                                :
                                <div>Noting has been set</div>
                            }
                            <button onClick={() => {
                                this.props.firestore.collection(COMPANY_DB_PATH)
                                    .doc(this.props.auth.uid).update({
                                    prices: this.state.prices
                                }).then(()=>{
                                    this.props.history.push(PROFILE_URL)
                                })
                            }}>Update
                            </button>
                        </div>
                        :
                        <div>
                            select service
                        </div>
                    }
                </div>
            );
        }

        return <div>Loading services settings ...</div>

    }
}

export default compose(
    withRouter,
    withFirestore,
    UserIsAuthenticated,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),

    firestoreConnect(props => {
            return [
                {
                    collection: COMPANY_DB_PATH,
                    doc: props.auth.uid,
                    storeAs: 'companyService'
                },
            ]
        }
    ),
    connect((state, props) => ({
        company: state.firestore.data.companyService,
    })),
    withCompanyManagerHOC,
)(CompanyServicePrices)